//Install
import React, { Component } from "react";

//Element
class Corporation extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB rj401n" },
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/about-us" },
                    //Element
                    "About Us"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/offices" },
                    //Element
                    "Offices"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/history" },
                    //Element
                    "History"
                )
            ),
            //Element
            React.createElement("li", { className: "S6pt64 C96Q4r" },
                //Element
                React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB", href: "/en/authorization-certificates" },
                    //Element
                    "Certificates"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Corporation;